import React, { ComponentProps } from "react";

function LockIconFilled(props: ComponentProps<"svg">) {
  return (
    <svg
      width={8}
      height={12}
      viewBox="0 0 8 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="lock.fill">
        <g id="Group">
          <path
            id="Vector"
            d="M1.73483 10.8635H6.43782C7.20051 10.8635 7.60041 10.4545 7.60041 9.63112V6.07402C7.60041 5.25339 7.20051 4.84848 6.43782 4.84848H1.73483C0.971239 4.84848 0.572266 5.25339 0.572266 6.07402V9.63112C0.572266 10.4545 0.971239 10.8635 1.73483 10.8635ZM1.49004 5.27045H2.43052L2.43142 3.57652C2.43142 2.40129 3.18578 1.75633 4.08427 1.75633C4.98094 1.75633 5.74628 2.40129 5.74628 3.57652L5.74444 5.27045H6.68172L6.68262 3.66984C6.68262 1.8167 5.45618 0.856934 4.08427 0.856934C2.71649 0.856934 1.49095 1.8167 1.49095 3.66984L1.49004 5.27045Z"
          />
        </g>
      </g>
    </svg>
  );
}

export default LockIconFilled;
